module.exports = __webpack_public_path__ + "assets/icons/project-inaccessible.svg";